/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum RoutesRoutes {
  ROUTE_CHAMADOS = '/chamados',
  ROUTE_CONSENTIMENTOS = '/consentimentos',
  ROUTE_DADOS_CONTRATO = '/dados-contrato',
  ROUTE_DADOS_PESSOAIS = '/dados-pessoais',
  ROUTE_DASHBOARD = '/',
  ROUTE_DEATLHES_CHAMADO = '/chamados/:nrSeqCall/detalhes',
  ROUTE_DETALHES_AUTORIZACAO = '/historico-autorizacoes/:nrSeqGuia',
  ROUTE_DETALHES_MENSAGEM = '/mensagens/:nrSeqComunicado/detalhes',
  ROUTE_DETALHES_REQUISICAO = '/historico-requisicoes/:nrSeqRequisicao',
  ROUTE_DETALHES_REQUISICAO_AUTORIZACAO = '/historico-requisicoes/:nrSeqRequisicao/autorizacao/:nrSeqGuia',
  ROUTE_DINAMICO = '/dinamico',
  ROUTE_HISTORICO_AUTORIZACOES = '/historico-autorizacoes',
  ROUTE_HISTORICO_CANCELAMENTOS = '/historico-cancelamentos',
  ROUTE_HISTORICO_PARTICIPACOES = '/historico-participacoes',
  ROUTE_HISTORICO_PROTOCOLOS = '/historico-protocolos',
  ROUTE_HISTORICO_REQUISICOES = '/historico-requisicoes',
  ROUTE_INFORMACOES_ADICIONAIS = '/informacoes-adicionais',
  ROUTE_MENSAGENS = '/mensagens',
  ROUTE_MENSALIDADES = '/mensalidades',
  ROUTE_MEUS_DADOS = '/meus-dados',
  ROUTE_NOVO_CHAMADO = '/chamados/tipo-solicitacao/:nrSeqCategory/novo',
  ROUTE_PRIVACY = '/privacidade',
  ROUTE_RECEBER_BOLETOS_EMAIL = '/receber-boletos-email',
  ROUTE_SOLICITAR_CANCELAMENTO = '/solicitar-cancelamento',
  ROUTE_SOLICITAR_PARTICIPACAO = '/solicitar-participacao',
  ROUTE_SOLICITAR_VIA = '/solicitar-via',
  ROUTE_TIPO_CHAMADO = '/chamados/tipo-solicitacao',
}
export { RoutesRoutes };
